module.exports = __webpack_public_path__ + "static/other/fossil_finder.fc5e96ad.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/fossil_finder.json
// module id = 2609
// module chunks = 0